import { ParentSize } from "@visx/responsive";

interface PriceChartSkeletonProps {
  readonly margin: {
    readonly top: number;
    readonly right: number;
    readonly bottom: number;
    readonly left: number;
  };
  readonly numYTicks: number;
  readonly numXTicks: number;
}

export function PriceChartSkeleton({
  margin,
  numYTicks,
  numXTicks,
}: PriceChartSkeletonProps) {
  return (
    <div
      style={{ position: "relative", width: "100%", height: "100%", opacity: 0.6 }}
    >
      <ParentSize>
        {({ width, height }) => {
          if (width === 0 || height === 0) return null;
          const plotTop = margin.top;
          const plotBottom = height - margin.bottom;
          const plotLeft = margin.left;
          const plotRight = width - margin.right;
          const rows = numYTicks;
          const cols = numXTicks;

          return (
            <svg width={width} height={height} aria-hidden="true">
              {Array.from({ length: rows }, (_, i) => {
                const y = plotTop + ((plotBottom - plotTop) / (rows - 1)) * i;
                return (
                  <g key={`skel-row-${y}`}>
                    <line
                      x1={plotLeft}
                      x2={plotRight}
                      y1={y}
                      y2={y}
                      stroke="rgba(194,214,255,0.06)"
                    />
                    <rect
                      x={plotRight + 6}
                      y={y - 5}
                      width={40}
                      height={10}
                      rx={2}
                      fill="rgba(194,214,255,0.06)"
                    />
                  </g>
                );
              })}
              {Array.from({ length: cols }, (_, i) => {
                const x = plotLeft + ((plotRight - plotLeft) / (cols - 1)) * i;
                return (
                  <rect
                    key={`skel-col-${x}`}
                    x={x - 14}
                    y={plotBottom + 10}
                    width={28}
                    height={8}
                    rx={2}
                    fill="rgba(194,214,255,0.06)"
                  />
                );
              })}
            </svg>
          );
        }}
      </ParentSize>
    </div>
  );
}
